import { TransportPlan } from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';
import { hasRelayPointApi } from '@savgroup-front-common/core/api/Claim/helpers/hasRelayPointApi';

export function getTransportPlansWithoutRelayPointApi(
  transportPlans: TransportPlan[] = [],
): TransportPlan[] {
  const cheapestTransportPlanByCarrier = transportPlans
    .filter((transportPlan) => !hasRelayPointApi(transportPlan))
    .reduce<Record<string, TransportPlan>>((acc, transportPlan) => {
      const currentTransportPlan = acc[transportPlan.carrier];

      if (
        currentTransportPlan &&
        (currentTransportPlan.priceWithTax ?? 0) <=
          (transportPlan.priceWithTax ?? 0)
      ) {
        return acc;
      }

      return { ...acc, [transportPlan.carrier]: transportPlan };
    }, {});

  return Object.values(cheapestTransportPlanByCarrier);
}
